const textFieldEquipStatusInput = {
  placeholder: 'Describa el motivo...',
  helperText: '* campo obligatorio'
};

export default textFieldEquipStatusInput;
